<template>
  <div id="app" ref="app" style="overflow-x: auto;">
    <!-- 缓存需要缓存的路由组件 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" />
    </keep-alive>
    <!-- 不缓存不需要缓存的路由组件 -->
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" />
    <BackTop  class="hidden-xs-only none_992" />
  </div>
</template>

<script>
import Home from '@/views/Home'
export default {
  name: 'App',
  components: {
    Home,
  },
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
@import url('./assets/css/icon.css');
</style>
